import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/pandan_honeycomb_cake.png";
import { Helmet } from "react-helmet";
import useMetaTracking from "../hooks/useMetaTracking";

function PandanHoneycombCake() {
  useMetaTracking("ViewContent", {
    content_name: "Pandan Honeycomb Cake",
    content_category: "Regular Menu",
    content_ids: ["pandan_honeycomb_cake"],
    content_type: "vietnamese_pastries",
    value: 8.0,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Pandan Honeycomb Cake | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Think of Pandan Honeycomb Cake (Bánh Bò Nướng) as the Vietnamese cousin of a sponge cake."
        />
        <meta
          property="og:title"
          content="Pandan Honeycomb Cake | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Think of Pandan Honeycomb Cake (Bánh Bò Nướng) as the Vietnamese cousin of a sponge cake."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Pandan Honeycomb Cake"
          titleSubHead="$8.00 each"
          detailBody="Think of Pandan Honeycomb Cake (Bánh Bò Nướng) as the Vietnamese cousin of a sponge cake. Light as a cloud, softly springy, and drifting notes of caramelized coconut & pandan's floral-vanilla fragrance with every slice."
          detailBodyBr="Contains: egg, gluten-free"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default PandanHoneycombCake;